import { Container, Button, Alert, Form, Table, Row, Col, Spinner, Modal } from 'react-bootstrap';
import { useState, useEffect } from 'react';
import axios from 'axios';
import "./list-grupos.css";
// import { TiDocumentAdd  } from "react-icons/ti";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { TiDelete, TiEdit  } from "react-icons/ti";
import { faAdd } from '@fortawesome/free-solid-svg-icons'; 

function ListGrupos() {

    const [items, setItems]                             = useState([]);
    const [showAlert, setShowAlert]                     = useState(false);
    const [showLoader, setShowLoader]                   = useState(false);
    const [showDelete, setShowDelete]                   = useState(false);
    const [showAdd, setShowAdd]                         = useState(false);
    const [deleteId, setDeleteId]                       = useState(false);
    const [showAlertDelete, setShowAlertDelete]         = useState(false);
    const [inputNombre, setInputNombre]                 = useState("");
    const [inputNivel, setInputNivel]                   = useState("");
    const [guardando, setGuardando]                     = useState(false);
    
    const [show, setShow]                               = useState(false);
    const [inputIdEdit, setInputIdEdit]                 = useState("");
    const [inputNombreEdit, setInputNombreEdit]         = useState("");     
    const [inputNivelEdit, setInputNivelEdit]           = useState("");     
    const [listadoNiveles, setListadoNiveles]           = useState([]);
    const [listadoNivelesEdit, setListadoNivelesEdit]   = useState([]);

    const handleCloseDelete                             = () => setShowDelete(false);
    const handleCloseAdd                                = () => setShowAdd(false);
    // const handleAdd                                  = () => addEvento(deleteId);
    const handleDelete                                  = () => deleteEvento(deleteId);


    const handleShow = (item_id) => {
            setShow(true);
            setInputIdEdit("")
            setInputNombreEdit("")
            setInputNivelEdit("");
            let ud = sessionStorage.getItem('userData');
            let userData = JSON.parse(ud);
    
            const instance = axios.create({
                    baseURL: '',
                    timeout: 5000,
                    headers: {'content-type': 'application/json', 'Authorization': 'Bearer '+userData.access_token}
                    });
            
                instance.get('api/get-grupo/'+item_id)
                .then(response => {
                    setInputIdEdit(response.data.data[0].id)
                    setInputNombreEdit(response.data.data[0].nombre)
                    setInputNivelEdit(response.data.data[0].id_nivel)
                })


            const instance2 = axios.create({
                    baseURL: '',
                    timeout: 5000,
                    headers: {'content-type': 'application/json', 'Authorization': 'Bearer '+userData.access_token}
                    });
            
                instance2.get('api/get-niveles')
                .then(response2 => {
                    setListadoNivelesEdit(response2.data)
                })
    
    }

    const handleSubmitEdit = async (event) => {
    
        event.preventDefault();
        console.log(inputNombreEdit)
    
        if( inputNombreEdit && inputNivelEdit ){
            
            var data_send = {
                "nombre": inputNombreEdit,
                "id_nivel": inputNivelEdit
            }
    
            let ud = sessionStorage.getItem('userData');
            let userData = JSON.parse(ud);
    
            const instance = axios.create({
                    baseURL: '',
                    timeout: 5000,
                    headers: {'content-type': 'application/json', 'Authorization': 'Bearer '+userData.access_token}
                    });
            
            instance.put('/api/update-grupo/'+inputIdEdit, data_send)
            .then(response => {
                //console.log(response)
                if(response.data.status === "200"){
                    // setInputNombreEdit("");
                    // setInputExistenciasEdit("");
                    setShow(false)
                    setShowAlert(true)
                    getData()
                }
            })
            .catch(function (error) {
                if(error.response.status === "401"){
                console.log(error)
                
                }
            });
    
    
        }
        else{
            //return error
            alert("Faltan datos"+inputNombreEdit);
        }
            
    }

    const handleClose = () => setShow(false);

    const deleteEvento=(id)=>{
                
            let ud = sessionStorage.getItem('userData');
            let userData = JSON.parse(ud);
    
            const instance = axios.create({
                    baseURL: '',
                    timeout: 5000,
                    headers: {'content-type': 'application/json', 'Authorization': 'Bearer '+userData.access_token}
                    });
            
                instance.delete('../api/delete-grupo/'+id)
                .then(response => {
                    if(response.status === 200){
                        setShowDelete(false);
                        setDeleteId("")
                        setShowAlertDelete(true)
                        getData()
                    }
                })

    }
    
    const getData= async () => {
        
        setShowLoader(true);
        let ud = sessionStorage.getItem('userData');
        let userData = JSON.parse(ud);

        const instance = axios.create({
                baseURL: '',
                timeout: 10000,
                headers: {'content-type': 'application/json', 'Authorization': 'Bearer '+userData.access_token}
                });
        

        await instance.get('../api/get-grupos')
        .then(response => {
            setItems(response.data)
            setShowLoader(false);
        })
    }

    useEffect(()=>{
        getData()
    },[])


    const handleSubmit = async (event) => {
        
        event.preventDefault();

        setGuardando(true);

        if( inputNombre ){
          
            let ud = sessionStorage.getItem('userData');
            let userData = JSON.parse(ud);
    
            var vuelto = {
                "nombre": inputNombre,
                "id_nivel": inputNivel
            }
          
            await fetch("api/add-grupo", {
                method: "POST",
                body: JSON.stringify(vuelto),
                headers: {'Content-Type':'application/json','Authorization': 'Bearer '+userData.access_token}
              })
              .then(response => {
                if(response.status === 200)
                    setShowAlert(true);
                    setInputNombre("");
                    setInputNivel("");
                    setGuardando(false);
                    getData()
                    setShowAdd(false);
              })
              .catch(function (error) {
                console.log(error);
              });
        
        }
        else{
            alert("Faltan Datos, por favor complete el formulario");
            setGuardando(false);
        }

    };

    const handleShowDelete = (item_id) => {
        setShowDelete(true);
        setDeleteId(item_id)
    }

    const handleShowAdd= async () => {
        setShowAdd(true);
        let ud = sessionStorage.getItem('userData');
        let userData = JSON.parse(ud);

        const instance = axios.create({
                baseURL: '',
                timeout: 10000,
                headers: {'content-type': 'application/json', 'Authorization': 'Bearer '+userData.access_token}
                });
        

        await instance.get('../api/get-niveles')
        .then(response => {
            setListadoNiveles(response.data)
        })
    }

  return (
        <>
            <Container>

                 <Row className='mt-4 mb-3 d-flex align-items-center justify-content-between'>
                    <Col lg={9} xs={12} md={9} className='mb-3'>
                        <h1 className='semibold mb-1'>Grupos</h1>
                    </Col>
        
                    <Col lg={2} xs={12} md={3}>
                        <Button type="button" onClick={() => handleShowAdd()} className='btn-primary semibold w-100 py-2'><FontAwesomeIcon icon={faAdd} size='1x' className='me-2'/>Crear Grupo</Button>
                    </Col>
                </Row>

                {
                    showLoader ? <>       
                    <div className='loader-div'>
                            <Spinner animation="border" className='spinner_color' color={'#097969'} role="status">
                                <span className="visually-hidden">Loading...</span>
                            </Spinner><br />
                            <h3 className='loading_txt'>Loading ...</h3>
                        </div></> : ""
                }
                <Alert className="mt-4" key="success" variant="success" show={showAlert} onClose={() => setShowAlert(false)} dismissible>
                    Se guardó exitosamente la información.
                </Alert>

                <Alert className="mt-4" key="successDelete" variant="success" show={showAlertDelete} onClose={() => setShowAlertDelete(false)} dismissible>
                    Se eliminó exitosamente la información.
                </Alert>

                <Table striped bordered hover responsive>
                    <thead>
                        <tr>
                            <th className='encabezado_tabla'>#</th>
                            <th className='encabezado_tabla'>Nombre</th>
                            <th className='encabezado_tabla'>Nivel</th>
                            <th className='encabezado_tabla'>Acciones</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            items && items.length > 0 && items.map((item, index) => {

                                return (
                                    <tr>
                                        <td className='data_tabla'>{index+1}</td>
                                        <td className='data_tabla'>{item.nombre_grupo}</td>
                                        <td className='data_tabla'>{item.nombre_nivel}</td>
                                        <td className='data_tabla'>
                                                                    <TiDelete className='icono_listado' onClick={() => handleShowDelete(item.id_gpo)} />
                                                                    <TiEdit className='icono_listado' onClick={() => handleShow(item.id_gpo)}  />
                                        </td>
                                    </tr>
                                )
                            })
                        }
                    </tbody>
                </Table>

            </Container>


            <Modal show={showAdd} onHide={handleCloseAdd}>
                <Modal.Header closeButton>
                <Modal.Title>Agregar Grupo</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Container>
                        <Form.Group className="mb-3" controlId="formBasicEmail">
                            <Form.Label htmlFor="input_nombre">Nombre</Form.Label>
                                <Form.Control 
                                id="input_nombre"
                                type="text" 
                                placeholder="Nombre"
                                defaultValue={inputNombre}
                                onKeyUp={(e) => setInputNombre(e.target.value)}
                                required />
                        </Form.Group>
                        <Form.Group className="mb-3" controlId="formBasicEmail">
                        <Form.Label htmlFor="input_nombre">Nivel</Form.Label>
                            <Form.Select aria-label="Seleccione..." onChange={(e) => setInputNivel(e.target.value)}>
                                <option>Seleccione...</option>
                                {
                                    listadoNiveles.map((item)=> 
                                        (<option value={item.id}>{item.nombre}</option>))
                                }
                            </Form.Select>
                        </Form.Group>

                    </Container>
                </Modal.Body>
                <Modal.Footer>
                <Button variant="secondary" onClick={handleCloseAdd}>
                    Cancelar
                </Button>
                    {!guardando ? (
                            <Button variant="primary" type="submit" onClick={(handleSubmit)}>
                                Guardar
                            </Button>
                        ) : (
                            <Button variant="primary" type="submit" disabled>
                                Guardando...
                            </Button>
                    )}
                </Modal.Footer>
            </Modal>

            <Modal show={show} onHide={handleClose}>
                <Modal.Header closeButton>
                <Modal.Title>Editar grupo</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                
                    <Form.Group className="mb-3" controlId="formBasicEmail">
                        <Form.Label htmlFor="input_nombre">Nombre del grupo</Form.Label>
                        <Form.Control 
                        id="input_nombre"
                        type="text" 
                        placeholder="Nombre del grupo"
                        defaultValue={inputNombreEdit}
                        onKeyUp={(e) => setInputNombreEdit(e.target.value)}
                        required />
                    </Form.Group>
                    <Form.Group className="mb-3" controlId="formBasicEmail">
                        <Form.Label htmlFor="input_nombre">Nivel</Form.Label>
                            <Form.Select aria-label="Seleccione..." value={inputNivelEdit} onChange={(e) => setInputNivelEdit(e.target.value)}>
                                <option>Seleccione...</option>
                                {
                                    listadoNivelesEdit.map((item)=> 
                                        (<option value={item.id}>{item.nombre}</option>))
                                }
                            </Form.Select>
                        </Form.Group>
                    <Row>
                        <Col>
                            <Button className='btn_buscar btn_right' type="submit" onClick={(handleSubmitEdit)}>
                                Guardar
                            </Button>
                        </Col>
                    </Row>
                </Modal.Body>
            </Modal>


            <Modal show={showDelete} onHide={handleCloseDelete}>
                <Modal.Header closeButton>
                <Modal.Title>Eliminar grupo</Modal.Title>
                </Modal.Header>
                <Modal.Body>¿Está seguro que desea eliminar este grupo?</Modal.Body>
                <Modal.Footer>
                <Button variant="secondary" onClick={handleCloseDelete}>
                    Cancelar
                </Button>
                <Button variant="danger" onClick={() => handleDelete()} >
                    Confirmar
                </Button>
                </Modal.Footer>
            </Modal>

        </>
  )
}

export default ListGrupos;